import { useEffect, useRef } from 'react';
import { BUGCROWD_PROGRAM_URL } from '../../constants/security';
import css from './security-report.module.scss';

export function BugcrowdSubmissionForm() {
  const formRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const formContainer = formRef.current;

    if (!formContainer) {
      return undefined;
    }

    const script = document.createElement('script');
    script.defer = true;
    script.async = false;
    script.src = `${BUGCROWD_PROGRAM_URL}/script`;
    script.dataset.bugcrowdProgram = `${BUGCROWD_PROGRAM_URL}/report`;

    formContainer.appendChild(script);

    return () => {
      formContainer.replaceChildren();
    };
  }, []);

  return <div ref={formRef} className={css.form} data-testid="bugcrowdSubmissionForm" />;
}
